import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { faEnvelope, faMobile } from '@fortawesome/pro-solid-svg-icons';
import { ModalController } from '@ionic/angular';
import { Warning } from '@shared/services';
import { SmartToastService } from '@shared/services/smartToast.service';
import { Auth } from 'aws-amplify';

@Component({
  selector: 'app-auth-verify-creds-modal',
  templateUrl: './auth-verify-creds-modal.component.html',
  styleUrls: ['./auth-verify-creds-modal.component.scss'],
})
export class AuthVerifyCredsModalComponent implements OnInit {
  @Input() user: any;
  @Input() email: string;
  @Input() phone: string;
  @Input() oldPhone: string;
  @Input() type: string;

  faEnvelope = faEnvelope;
  faMobile = faMobile;

  // Array to store each digit of the verification code
  codeDigits: string[] = ['', '', '', '', '', ''];

  // Track the original single code property
  get code(): string {
    return this.codeDigits.join('');
  }

  set code(value: string) {
    if (value) {
      const digits = value.split('').slice(0, 6);
      this.codeDigits = [...digits, ...Array(6 - digits.length).fill('')];
    } else {
      this.codeDigits = ['', '', '', '', '', ''];
    }
  }

  constructor(private modalCtrl: ModalController, private warning: Warning, private smartToastService: SmartToastService) {}

  ngOnInit() {
    if (this.type !== 'confirm_signup') {
      this.updateAuthUser();
    }
  }

  async sendCodeToEmail() {
    Auth.verifyCurrentUserAttribute('email')
      .then(() => {})
      .catch(e => {
        console.log(e);
      });
  }

  async sendCodeToPhone() {
    Auth.verifyCurrentUserAttribute('phone_number')
      .then(() => {})
      .catch(e => {
        console.log(e);
      });
  }

  async sendConfirmCode() {
    try {
      await Auth.resendSignUp(this.email);
    } catch (error) {
      this.warning.create(error);
    }
  }

  async updateAuthUser() {
    const user = await Auth.currentAuthenticatedUser();

    if (this.type == 'email') {
      Auth.updateUserAttributes(user, {
        email: this.email,
      });
    } else if (this.type == 'phone') {
      try {
        Auth.updateUserAttributes(user, {
          phone_number: this.phone,
        }).then(() => {
          Auth.verifyCurrentUserAttribute('phone_number');
        });
      } catch (error) {
        this.warning.create(error);
        if (this.oldPhone) {
          Auth.updateUserAttributes(user, { phone_number: this.oldPhone });
        }
      }
    }
  }

  resendCode() {
    if (this.type === 'email') {
      this.sendCodeToEmail();
    } else if (this.type === 'phone') {
      this.sendCodeToPhone();
    } else if (this.type === 'confirm_signup') {
      this.sendConfirmCode();
    }
    this.smartToastService.show('A new verification code has been sent', 'success', 10000);
  }

  configureVerifyFunction() {
    if (this.type === 'confirm_signup') {
      this.verifySignup();
    } else {
      this.verifyCodeFromEmail();
    }
  }

  async verifyCodeFromEmail() {
    if (this.code) {
      const attribute = this.type === 'email' ? 'email' : 'phone_number';
      Auth.verifyCurrentUserAttributeSubmit(attribute, this.code)
        .then(() => {
          this.dismiss(true);
        })
        .catch(e => {
          this.warning.create('Invalid Code', 'Unsuccessful Action');
          // this.dismiss(false);
        });
    }
  }

  async verifySignup() {
    if (this.code && this.type === 'confirm_signup') {
      try {
        await Auth.confirmSignUp(this.email, this.code).then(response => {
          this.dismiss(true);
        });
      } catch (error) {
        this.warning.create(error);
      }
    }
  }

  /**
   * Handle keyup event on digit input
   * @param event Keyboard event
   * @param index Current input index
   * @param currentInput Current input element
   * @param nextInput Next input element
   */
  onDigitKeyup(event: KeyboardEvent, index: number, currentInput: HTMLInputElement, nextInput: HTMLInputElement | null) {
    const key = event.key;

    if (key === 'Backspace' || key === 'Delete') {
      // If input is cleared and there's a previous input, focus the previous one
      if (!this.codeDigits[index] && index > 0) {
        const prevInput = document.getElementById(`codeInput${index}`) as HTMLInputElement;
        if (prevInput) {
          prevInput.focus();
        }
      }
    } else if (/^[0-9]$/.test(key)) {
      // If a digit is entered and there's a next input, focus the next one
      if (nextInput && this.codeDigits[index]) {
        nextInput.focus();
      }
    }

    // Update the overall code value
    const combinedCode = this.codeDigits.join('');
    if (combinedCode.length === 6) {
      // Optionally auto-verify when all digits are filled
      // this.configureVerifyFunction();
    }
  }

  /**
   * Handle paste event on any of the inputs
   * @param event Paste event
   */
  onCodePaste(event: ClipboardEvent) {
    event.preventDefault();

    if (event.clipboardData) {
      const pastedData = event.clipboardData.getData('text');
      // Extract only digits
      const digits = pastedData
        .replace(/[^0-9]/g, '')
        .split('')
        .slice(0, 6);

      // Fill in the available digits
      digits.forEach((digit, index) => {
        if (index < 6) {
          this.codeDigits[index] = digit;
        }
      });

      // Focus the next unfilled input or the last input
      const nextEmptyIndex = this.codeDigits.findIndex(digit => !digit);
      if (nextEmptyIndex > -1 && nextEmptyIndex < 6) {
        const nextInput = document.getElementById(`codeInput${nextEmptyIndex + 1}`) as HTMLInputElement;
        if (nextInput) {
          nextInput.focus();
        }
      } else {
        const lastInput = document.getElementById('codeInput6') as HTMLInputElement;
        if (lastInput) {
          lastInput.focus();
        }
      }

      // If all digits are filled, optionally auto-verify
      if (this.code.length === 6) {
        // this.configureVerifyFunction();
      }
    }
  }

  changeEmail() {
    this.dismiss(false);
  }

  dismiss(status: boolean) {
    this.modalCtrl.dismiss({ verified: status });
  }
}
